'use client';

import {
  LDProvider as FeatureManagementLDProvider,
  useFlags,
} from '@thrivent-web/feature-management/client';
import {
  FlaggedHeader,
  HeaderProps,
} from '@thrivent/thrivent-public-header-footer';

// --------------------------------------------------------------------------

// Ideally, we wouldn't need this, but many apps define the layout in their error.tsx pages,
// error.tsx is unable to read process.env, so in those rare cases we can just fall back to whatever is in prod
const PROD_CLIENT_ID = '6643c9091798a10fb73705b4';

const LDProvider = ({ children }: { children: React.ReactNode }) => (
  <FeatureManagementLDProvider
    clientSideID={
      process.env.NEXT_PUBLIC_HEADER_FOOTER_LD_CLIENT_SIDE_ID || PROD_CLIENT_ID
    }
  >
    {children}
  </FeatureManagementLDProvider>
);
const HeaderProvided = (props: HeaderProps) => {
  const flags = useFlags();
  return <FlaggedHeader {...props} flags={flags} />;
};

export const HeaderWithProvider = (props: HeaderProps) => {
  return (
    <LDProvider>
      <HeaderProvided {...props} />
    </LDProvider>
  );
};
